/* global Shopify */
class Header {
    constructor() {
        this.header = document.querySelector('.header_main');
        this.oldScrollValue = 0;
        this.selectedMenuIndex = 99;
        this.isMessageDialogOpen = false;
        this.isMessageOnQueue = false;

        this.init();
    }

    checkHeaderColor(direction) {
        if (window.scrollY === 0) {
            let list = this.header.classList;

            if (!list.contains('black_color') && direction === 'over') {
                list.add('black_color');
            } else {
                list.remove('black_color');
            }
        }
    }

    init() {
        this.header.addEventListener("mouseover", () => {
            this.checkHeaderColor('over');
        });

        this.header.addEventListener("mouseout", () => {
            this.checkHeaderColor('out');
        });

        this.header.addEventListener("mouseleave", () => {
            this.showSubmenu('99');
            this.underlineCurrentMenuIndex();
        });

        this.header.querySelectorAll('.menu_link_level_0.link_submenu > a').forEach(element => {
            element.addEventListener("mouseover", () => {
                let index = element.getAttribute('data-index-submenu');
                this.showSubmenu('99');
                setTimeout(() => {
                    this.showSubmenu(index);
                }, 200);
            });
        });

        this.header.querySelectorAll('.menu_link_level_0:not(.link_submenu) > a').forEach(element => {
            element.addEventListener("mouseover", () => {
                this.showSubmenu('99');
            });
        });

        window.addEventListener('scroll', () => {
            let newValue = window.scrollY;

            if (this.oldScrollValue === 0 && newValue < 0) {
                return;
            }

            let list = this.header.classList;

            if (newValue > 0) {
                list.add('black_color');
            } else {
                list.remove('black_color');
            }

            if (this.oldScrollValue < newValue && !list.contains('scrollOut') && newValue > 0) {
                list.add('scrollOut');
                this.showSubmenu('99');
            } else if (this.oldScrollValue > newValue && list.contains('scrollOut')) {
                list.remove('scrollOut');
            }

            this.oldScrollValue = newValue;
        });

        if (window.scrollY > 0) {
            this.header.classList.add('black_color');
        }

        let current_url = window.location.pathname;

        this.header.querySelectorAll('.header_submenu_section').forEach(
            element => {
                let index = element.dataset.index;
                element.querySelectorAll('a').forEach(
                    link => {
                        if (link.getAttribute('href') === current_url) {
                            this.header.querySelector(`.header_main a[data-index-submenu="${index}"]`)
                                .classList.add('underline');
                            this.selectedMenuIndex = index;
                        }
                    }
                );
            }
        );

        let links = this.header.querySelectorAll('.menu_link_level_0 a');
        links.forEach(
            element => {
                element.addEventListener('mouseover', () => {
                    let index = element.dataset.indexSubmenu;
                    element.classList.add('underline');

                    let links_underline = this.header.querySelectorAll(
                        '.menu_link_level_0 a.underline');
                    links_underline.forEach(
                        sibling => {
                            if (sibling.dataset.indexSubmenu !== index) {
                                sibling.classList.remove('underline');
                            }
                        });
                });
            }
        );

        this.checkPageMessages();
    }

    showSubmenu(index) {
        let submenu_sections = document.querySelectorAll('.header_main .header_submenu_section');

        submenu_sections.forEach(section => {
            if (section.getAttribute('data-index') === index) {
                this.showOrHide(section, true);
            } else {
                this.showOrHide(section, false);
            }
        });
    }

    showOrHide(element, toShow) {
        let list = element.classList;

        if (toShow) {
            list.add('open');
        } else {
            list.remove('open');
        }
    }

    underlineCurrentMenuIndex() {
        let siblings = this.header.querySelectorAll('.menu_link_level_0 a');
        setTimeout(() => {
            siblings.forEach(
                sibling => {
                    if (sibling.dataset.indexSubmenu === this.selectedMenuIndex) {
                        sibling.classList.add('underline');
                    } else {
                        sibling.classList.remove('underline');
                    }
                }
            );
        }, 600);
    }

    checkPageMessages() {
        let errors = document.querySelectorAll('div.errors li');
        let success_msg = document.querySelectorAll('div.success_msg');

        let params = new URL(window.location.href).searchParams;

        if (errors.length > 0) {
            errors.forEach(
                message => {
                    this.setHeaderMessage(message.innerHTML, 'error');
                }
            );
        } else if (params.has('posted_form')) {
            this.setHeaderMessage(Shopify.dialog_message(params.get('posted_form')));
        } else if (success_msg.length > 0) {
            success_msg.forEach(
                message => {
                    this.setHeaderMessage(message.innerHTML);
                }
            );
        }
    }

    setHeaderMessage(msg, type = 'success') {

        if (this.isMessageDialogOpen) {
            this.isMessageOnQueue = true;
        }

        let msg_container = document.getElementById('page_messages');
        let message = msg_container.querySelector('#page_messages .message');

        message.innerHTML = msg;

        switch (type) {
            case 'success':
                message.classList.add('bg-success');
                break;
            default:
                message.classList.add('bg-error');
                break;
        }

        msg_container.hidden = false;
        this.isMessageDialogOpen = true;

        setTimeout(() => {
            if (!this.isMessageOnQueue) {
                msg_container.hidden = true;
            }

            this.isMessageDialogOpen = false;
            this.isMessageOnQueue = false;
        }, 8000);
    }
}

Shopify.header = new Header();
